// Legacy naming: the mascot system predates the Screen Tim rebrand (Aug 2026).
// "Magnum" in component/context/lib names refers to what is now Tim, the mascot.
// Kept to avoid repo-wide churn; user-facing strings say Tim.
import { apiFetch } from '@/lib/apiFetch'

export interface EffectData {
  effectType: string
  name: string
  config: string | null
}

export interface InteractionContext {
  contextType: string
  exerciseType?: string
  category?: string
  wordId?: number
  wordText?: string
  responseGiven?: string
  correct?: boolean
  responseMs?: number
  activeMs?: number
  streak: number
  sessionId?: number | null
  /** Free-form extras merged into the engine's context map — see FACET_DEFINITIONS. */
  facets?: Record<string, string>
}

export interface BrokenRecord {
  recordType: string
  oldValue: number
  newValue: number
}

export interface SessionTimingResult {
  sessionAvgMs: number
  sessionFastestMs: number
  attemptCount: number
  newRecords: BrokenRecord[]
}

export interface EngineResponse {
  line: { id: number; text: string } | null
  effects: EffectData[] | null
  timing: SessionTimingResult | null
}

export async function fetchMagnumMoment(ctx: InteractionContext): Promise<EngineResponse> {
  return apiFetch<EngineResponse>('/magnum/moment', {
    method: 'POST',
    body: JSON.stringify(ctx),
  })
}
